import * as React from 'react';
import Button from '@mui/material/Button';
import CssBaseline from '@mui/material/CssBaseline';
import TextField from '@mui/material/TextField';
import Box from '@mui/material/Box';
import Container from '@mui/material/Container';
import { createTheme } from '@mui/material/styles';
import { getSentence } from './translations';
import { use_recovery_link } from './Network';
import { setCredentials } from './Cookies';
import Alert from '@mui/material/Alert';


export class RecoveryPage extends React.Component 
{

    constructor()
    {
        super();
        this.handleConfirm = this.handleConfirm.bind(this)

        this.state = {
            passwd: "",
            passwdError: "",
            passwdHelperText: "",
            errorMsg: ""
        }    
    }

    async handleConfirm(event)
    {   //check that the passwords are the same and send the change to the server.

        event.preventDefault();
        const data = new FormData(event.currentTarget);

        if (data.get("password") === "" || data.get("password") !== data.get("passwordCheck"))
        {
            this.setState({ passwdError: true});
            this.setState({ passwdHelperText: getSentence(17)});
        }
        else
        {
            const link = window.location.pathname.split('/')[2]
            const user = await use_recovery_link(link, data.get("password"))

            if (user != 500)
            {
                await setCredentials(user, data.get("password"), false);
                window.location.assign("/")
            }
            else
            {
                const errormsg = <Alert severity="error">{getSentence(60)}</Alert>
                this.setState({ errorMsg: errormsg});
            }
        }
    };
  

    render()
    {
        return (
            <Container component="main" maxWidth="xs">
                {this.state.errorMsg}
                <CssBaseline />
                <Box
                sx={{
                    marginTop: 8,
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                }}
                >
                    <Box component="form" onSubmit={this.handleConfirm} noValidate sx={{ mt: 1 }}>
                        <TextField
                            margin="normal"
                            required
                            fullWidth
                            name="password"
                            label={getSentence(22)}
                            type="password"
                            id="password"
                            autoComplete="current-password"
                            error = {this.state.passwdError}
                            helperText={this.state.passwdHelperText}
                        />
                        <TextField
                            margin="normal"
                            required
                            fullWidth
                            name="passwordCheck"
                            label={getSentence(34)}
                            type="password"
                            id="passwordCheck"
                            autoComplete="current-password"
                            error = {this.state.passwdError}
                            helperText={this.state.passwdHelperText}
                        />
                        
                        <Button
                            type="submit"
                            fullWidth
                            variant="contained"
                            sx={{ mt: 3, mb: 2 }}
                        >
                            {getSentence(39)}
                        </Button>
                    </Box>
                    
                </Box>
            </Container>
          );
    }
  
}